import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownOption, TabsComponent } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { ClassEnrolmentCardComponent } from 'src/app/components/class-enrolment-card/class-enrolment-card.component';
import { BulkCourseEnrolmentStatusUpdate, EnrolmentStatus, EnrolmentType } from 'src/app/models/class-enrolment.model';
import { CourseDTO, GroupEnrolment } from 'src/app/models/course-dto.model';
import { TrainingProgramApplicationProcessInfoModel } from 'src/app/models/training-program-application-process-info.model';
import { CourseService } from 'src/app/services/course/course.service';
import { TrainingProgramService } from 'src/app/services/training-program/training-program.service';
import { WorkerService } from 'src/app/services/worker-service/worker.service';
import { FormatUtil } from 'src/app/utils/format.util';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';
import { bannerService } from 'src/app/services/banner-service/banner.service';
import { Observable } from 'rxjs';
@Component({
    selector: 'app-view-classroom',
    templateUrl: './view-classroom.component.html',
    styleUrls: ['../create-classroom/create-classroom.component.scss', './view-classroom.component.scss'],
    providers: [{ provide: 'WorkerService', useClass: WorkerService }],
    standalone: false
})
export class ViewClassroomComponent extends BaseComponent implements OnInit {
  @ViewChild('tabs') tabsComponent: TabsComponent
  @ViewChild('enroltabs') enrolTabsComponent: TabsComponent
  @ViewChildren('pendingcards') pendingcards: QueryList<ClassEnrolmentCardComponent>;

  tpAppUtils = TrainingProgramApplicationUtils;
  formatUtils = FormatUtil
  currentLang: string = 'en';
  courseId: string;
  classRoom: CourseDTO;

  isEditSucceed: boolean = false
  showCompletedEnrollmentButtons: boolean = false;
  isUpdate: boolean = false
  isApiClass: boolean = false

  isCancelledEnroledTabSelected: boolean = false;
  isPendingEnroledTabSelected: boolean = false;
  isConfirmedEnroledTabSelected: boolean = false;
  enrolmentTabSelected: boolean = false;
  isEnrolmentCancelled: boolean = false;
  ispendingLearnerInfoIncomplete: boolean = false;
  isCancelledLearnerInfoIncomplete: boolean = false;

  unReadCount: number = 0;
  enrolmentsCount: number = 0;
  totalPendingLearnerCount: number = 0;
  totalConfirmedLearnerCount: number = 0;
  totalCompletedLearnerCount: number = 0;
  totalCancelledLearnerCount: number = 0;

  showPendingEnrolmentConfirmedBanner: boolean = false;
  showCancelledEnrolmentConfirmedBanner: boolean = false;
  showCancelledEnrolmentBannerObservable: Observable<boolean>;

  // handle banner hide/show from worker-enrolment for tp/view-classroom
  showWorkerEnrolmentForTpConfirmedBanner: boolean = false;
  showWorkerEnrolmentForTpPendingBanner: boolean = false;
  enrolmentsCountsForTpBanner: number = 0;
  enrolmentsSelfBanner: boolean = true;
  enrolmentUpdateStatus: boolean = false;
  showLearnerInfoConflictBanner: boolean = false;
  conflictingEmails: string[] = [];

  enrolmentsCompleted: boolean = false;
  enrolmentsConfirmed: boolean = false;
  selectSubmittedRecordsTab: boolean = false;
  sortingOptions: DropdownOption[] = [new DropdownOption('Date updated', 'Date de mise à jour', 1)];
  TrainingProgramApplicationList: TrainingProgramApplicationProcessInfoModel[] = [];

  bannerType: string
  bannerText: string
  bannerDate = '';
  bannerProgram = '';

  hasSelectedActiveTab: boolean = false;
  completedBeforeOptions: DropdownOption[] = [
    new DropdownOption(this.translateService.instant('CreateClassroom.SameDay'), this.translateService.instant('CreateClassroom.SameDay'), 0),
    new DropdownOption(this.translateService.instant('CreateClassroom.OneDay'), this.translateService.instant('CreateClassroom.OneDay'), 1),
    new DropdownOption(this.translateService.instant('CreateClassroom.TwoDays'), this.translateService.instant('CreateClassroom.TwoDays'), 2)
  ]
  selectedCancelledRegistrationIds: string[] = [];
  selectedPendingRegistrationIds: string[] = [];
  selectedConfirmedRegistrationIds: string[] = [];
  updatedPendingRegistrationIds: string[] = [];
  incompletedPendingRegistrationIds: string[] = [];

  isConfirmed = false
  isLearnerDetailsIncomplete = false;
  isWAH: boolean;
  hideSelectDays: boolean;
  showEnrolmentCompletedBanner: boolean = false;
  isClassRoomActive: boolean = false;
  formatUtil = FormatUtil;
  bannerState: number = 0;

  constructor(public router: Router,
    public route: ActivatedRoute,
    public translateService: TranslateService,
    private bannerService: bannerService,
    @Inject('TrainingProgramService') public trainingProgramService: TrainingProgramService,
    @Inject('CourseService') public courseService: CourseService,
    @Inject('WorkerService') public workerService: WorkerService,
    public datePipe: DatePipe) {
    super();
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => { if (params['courseId']) this.courseId = params['courseId']; })
    this.showCancelledEnrolmentBannerObservable = this.bannerService.currentBannerState;
    this.route.queryParams.subscribe(param => {
      if (param['showEnCompBan'] && param['showEnCompBan'] == 'true')
        this.showEnrolmentCompletedBanner = true;
      if (param['success'] != null && param['success'] != undefined) {
        if (param['date'] != null && param['date'] != undefined) this.bannerDate = param['date'];
        this.bannerProgram = param['program'];
        this.isEditSucceed = true;
      }
      if (param['status']) {
        this.isEnrolmentCancelled = (param['status'] == 'cancelled');
        this.bannerProgram = param['program'];
      }
      if (param['edit']) {
        this.isUpdate = true
        if (param['edit'] == 'false') this.isConfirmed = true;
      }
      // handle banner hide/show from worker-enrolment for tp/view-classroom
      if (param['isTP']) {
        const status = param['status'] && !Number.isNaN(param['status']) ? Number(param['status']) : 0;
        this.enrolmentsCountsForTpBanner = param['enrolmentCount'] && !Number.isNaN(param['enrolmentCount']) ? Number(param['enrolmentCount']) : 0;
        this.enrolmentsSelfBanner = param['self'] && param['self'] == 'true';
        const tab = param['tab'];
        if (tab === 'enrolment' && status === EnrolmentStatus.EnrolmentStatusConfirmed) {
          this.showWorkerEnrolmentForTpConfirmedBanner = true;
          this.isConfirmed = true;
        }
        if (tab === 'enrolment' && status === EnrolmentStatus.EnrolmentStatusPending) {
          this.showWorkerEnrolmentForTpPendingBanner = true;
          this.isConfirmed = false;
        }

        var conflictingEmailsFromEnrolment = sessionStorage.getItem('conflictingEmails');
        if (conflictingEmailsFromEnrolment) {
          this.conflictingEmails = JSON.parse(conflictingEmailsFromEnrolment);
        }
      }
      if (param['update']) {
        this.enrolmentUpdateStatus = param['update'] == 'success' ? true : false;
        if (this.enrolmentUpdateStatus) {
          this.showWorkerEnrolmentForTpConfirmedBanner = false;
          this.showWorkerEnrolmentForTpPendingBanner = false;
        }
      }
    })
    this.loadEnrolments();
  }

  getConflictingEmailsList() {
    let result = ''
    this.conflictingEmails.forEach(x => { result += `<li>${x}</li>`; });
    return result;
  }

  goBack() { this.router.navigate(['../../training-schedules'], { relativeTo: this.route }); }

  getLocalTimeString(time: string) {
    if (time.indexOf('Z') == -1) time += 'Z';
    return this.datePipe.transform(time, "h:mm a")?.toUpperCase()
  }

  getTimeString(time: number) {
    let timeString = (time % 1200 == 0 ? 1200 : time % 1200).toString()
    switch (time) {
      case 1200:
      case 1230:
        timeString = time.toString()
        break;
      default:
        timeString = (time % 1200).toString()
    }

    let hourNum = Number.parseInt(timeString.substring(0, timeString.length - 2))
    let hourString = (hourNum % 12 == 0 ? 12 : hourNum % 12).toString()
    let minuteString = timeString.substring(timeString.length - 2)
    let amPm = (time >= 1200 ? 'PM' : 'AM')

    return `${hourString}:${minuteString} ${amPm}`
  }

  setActiveTab() {
    this.route.queryParams.subscribe((routeQueryParams) => {
      if (routeQueryParams['tab']) {
        if (routeQueryParams['banner'] && routeQueryParams['banner'] == 'successSent') {
          this.bannerType = 'success'
          this.bannerText = this.translateService.instant('CreateNotification.NotificationsSentSuccessfullyBanner')
        }
        const tabToSelect = routeQueryParams['tab'];
        setTimeout(x => {
          let tabs = this.tabsComponent.tabs;
          if (tabs) {
            const currentActiveTab = this.tabsComponent.tabs.toArray().find(x => x.active);
            if (currentActiveTab) currentActiveTab.active = false;
          }
          if (tabToSelect === 'enrolment') {
            this.tabsComponent.tabs.toArray()[1].active = true;
            this.enrolmentTabSelected = true;

            const subtab = routeQueryParams['status'];
            if (subtab == EnrolmentStatus.EnrolmentStatusPending) {
              this.enrolTabsComponent.tabs.toArray()[1].active = true;
              this.enrolTabsComponent.tabs.toArray()[0].active = false;
              this.enrolTabsComponent.tabs.toArray()[2].active = false;
            }
            else if (subtab == EnrolmentStatus.EnrolmentStatusCanceled) {
              this.enrolTabsComponent.tabs.toArray()[0].active = false;
              this.enrolTabsComponent.tabs.toArray()[1].active = false;
              this.enrolTabsComponent.tabs.toArray()[2].active = true;
            } else {
              this.enrolTabsComponent.tabs.toArray()[0].active = true;
              this.enrolTabsComponent.tabs.toArray()[1].active = false;
              this.enrolTabsComponent.tabs.toArray()[2].active = false;
            }
          }
          if (tabToSelect === 'notification') {
            this.tabsComponent.tabs.toArray()[2].active = true;
          }
          if (tabToSelect === 'SuccessfulCompletion') {
            this.showCompletedEnrollmentButtons = true;
            this.tabsComponent.tabs.toArray()[1].active = true;
          }

          if (this.isEnrolmentCancelled) {
            this.enrolTabsComponent.tabs.toArray()[0].active = false;
            this.enrolTabsComponent.tabs.toArray()[2].active = true;
            this.isCancelledEnroledTabSelected = true
          }
          else if (this.showWorkerEnrolmentForTpPendingBanner) {
            this.enrolTabsComponent.tabs.toArray()[0].active = false;
            this.enrolTabsComponent.tabs.toArray()[1].active = true;
          }

          if (this.enrolmentsConfirmed) {
            this.enrolTabsComponent.tabs.toArray()[0].active = true;
            this.enrolTabsComponent.tabs.toArray()[1].active = false;
            this.enrolTabsComponent.tabs.toArray()[2].active = false;
            this.showWorkerEnrolmentForTpPendingBanner = false;
            this.enrolmentsConfirmed = false;
            this.showWorkerEnrolmentForTpConfirmedBanner = true;
            this.isConfirmed = true;
          }
        });
      }
      this.hasSelectedActiveTab = true
    });
  }

  getCompletedBeforeDate() {
    if (this.classRoom.DaysBeforeClassRequirement == 0) return this.datePipe.transform(this.classRoom.ClassTimes[0].ClassDate, 'MMMM dd, yyyy')
    else {
      let daysAway = -(this.classRoom.DaysBeforeClassRequirement!) + 1
      let scheduledDate = this.datePipe.transform(this.classRoom.ClassTimes[0].ClassDate, 'yyyy-MM-dd')!
      let prevDateFormatted = new Date(scheduledDate + 'Z')
      prevDateFormatted.setDate((prevDateFormatted.getDate() + daysAway))
      return this.datePipe.transform(prevDateFormatted, 'MMMM dd, yyyy')
    }
  }

  showBlendedSection(): boolean {
    return this.tpAppUtils.Blended == this.classRoom.TrainingType?.TrainingTypeId.toLocaleLowerCase();
  }

  getSelectedCompletedBeforeOption() {
    let option = this.completedBeforeOptions.find(x => x.value == this.classRoom.DaysBeforeClassRequirement)
    return this.currentLang == 'fr' ? option?.nameFr : option?.name
  }

  refreshSelectedPendingRegistrationIds(updateEvent: any): void {
    updateEvent.selectedPendingRegistrationIds.forEach(registrationId => {
      if (updateEvent.checked) {
        if (this.selectedPendingRegistrationIds.findIndex(x => x == registrationId) < 0)
          this.selectedPendingRegistrationIds.push(registrationId);
      }
      else {
        if (this.selectedPendingRegistrationIds.findIndex(x => x == registrationId) >= 0)
          this.selectedPendingRegistrationIds.splice(this.selectedPendingRegistrationIds.findIndex(x => x == registrationId), 1);
      }
    });
  }

  refreshSelectedCancelledRegistrationIds(updateEvent: any): void {
    for (let registrationId of updateEvent.selectedPendingRegistrationIds) {
      if (updateEvent.checked) {
        if (this.selectedCancelledRegistrationIds.filter(x => x == registrationId).length == 0)
          this.selectedCancelledRegistrationIds.push(registrationId);
      }
      else this.selectedCancelledRegistrationIds = this.selectedCancelledRegistrationIds.filter(x => x != registrationId);
    }
  }

  refreshSelectedConfirmedRegistrationIds(updateEvent: any): void {
    this.bannerState = 0;
    this.selectedConfirmedRegistrationIds = updateEvent.selectedConfirmedRegistrationIds;
    this.isLearnerDetailsIncomplete = updateEvent.isLearnerInfoIncomplete;
  }

  checkIfAnyIncompletedEnrolmentSelected() {
    let result = false;
    this.selectedPendingRegistrationIds.forEach(registrationId => {
      if (this.incompletedPendingRegistrationIds.findIndex(x => x == registrationId) >= 0) result = true;
    })
    return result;
  }

  checkIfPendingEnroledTabSelected() {
    this.isCancelledEnroledTabSelected = this.tabsComponent && this.enrolTabsComponent && this.tabsComponent.tabs.toArray()[1].active && this.enrolTabsComponent.tabs.toArray()[2].active;
    this.isPendingEnroledTabSelected = this.tabsComponent && this.enrolTabsComponent && this.tabsComponent.tabs.toArray()[1].active && this.enrolTabsComponent.tabs.toArray()[1].active;
    this.isConfirmedEnroledTabSelected = this.tabsComponent && this.enrolTabsComponent && this.tabsComponent.tabs.toArray()[1].active && this.enrolTabsComponent.tabs.toArray()[0].active;

    this.enrolmentTabSelected = (this.isCancelledEnroledTabSelected || this.isPendingEnroledTabSelected || this.isConfirmedEnroledTabSelected);
    if (this.enrolmentsCompleted) this.selectSubmittedRecordsTab = this.tabsComponent.tabs.toArray()[1].active;
  }

  getLearnerCount(enrolments: GroupEnrolment[], status: EnrolmentStatus): number {
    let result = 0
    for (let enrol of enrolments) {
      enrol.LearnerCount = enrol.Enrolments.filter((f: any) => f.EnrolmentStatus == status && !f.IsPrimary).length
      result += enrol.LearnerCount
    }
    return result
  }

  loadEnrolments() {
    this.incompletedPendingRegistrationIds = [];
    this.courseService.GetCourseByCourseId(this.courseId).subscribe((course => {
      this.classRoom = course;
      this.isApiClass = this.classRoom.CreatedBy === 'API'
      this.isClassRoomActive = this.classRoom.Status === this.tpAppUtils.Active;
      // Populate enrollments
      if (this.classRoom.CompletedGroupEnrolments.length > 0) this.enrolmentsCompleted = true;
      this.totalPendingLearnerCount = this.getLearnerCount(this.classRoom.PendingGroupEnrolments, EnrolmentStatus.EnrolmentStatusPending);
      this.totalConfirmedLearnerCount = this.getLearnerCount(this.classRoom.ConfirmedGroupEnrolments, EnrolmentStatus.EnrolmentStatusConfirmed);
      this.totalCompletedLearnerCount = this.getLearnerCount(this.classRoom.CompletedGroupEnrolments, EnrolmentStatus.EnrolmentStatusCompleted);
      this.totalCancelledLearnerCount = this.getLearnerCount(this.classRoom.CancelledGroupEnrolments, EnrolmentStatus.EnrolmentStatusCanceled);
      this.enrolmentsCount = this.classRoom.PendingGroupEnrolments.length + this.classRoom.ConfirmedGroupEnrolments.length + this.classRoom.CancelledGroupEnrolments.length;
      this.excludePrimaryContactIfItsLearner();
      this.setActiveTab();
      this.checkPendingCencelledIncomplete();
      this.isWAH = this.classRoom.TrainingProgramId?.toLowerCase() == this.tpAppUtils.WAHFull;
      this.hideSelectDays = !this.isWAH && this.tpAppUtils.eLearning == this.classRoom.TrainingType?.TrainingTypeId.toLocaleLowerCase();
      setTimeout(() => {
        this.checkIfPendingEnroledTabSelected();
      });
    }));
  }

  checkPendingCencelledIncomplete(): void {
    this.ispendingLearnerInfoIncomplete = false;
    this.isCancelledLearnerInfoIncomplete = false;

    this.checkLearnerIncompleteInformation(this.classRoom.PendingGroupEnrolments);
    this.checkLearnerIncompleteInformation(this.classRoom.CancelledGroupEnrolments);

    let cancelledInfoIncomp = false;
    let pendingInfoIncomp = false;

    this.classRoom.PendingGroupEnrolments.forEach(x => {
      pendingInfoIncomp = x.Enrolments.some(x => x.isInfoIncomplete == true)
      if (pendingInfoIncomp) this.ispendingLearnerInfoIncomplete = true;
    });

    this.classRoom.CancelledGroupEnrolments.forEach(x => {
      cancelledInfoIncomp = x.Enrolments.some(x => x.isInfoIncomplete == true)
      if (cancelledInfoIncomp) this.isCancelledLearnerInfoIncomplete = true;
    })
  }

  checkLearnerIncompleteInformation(groupEnrolments: GroupEnrolment[]): void {
    groupEnrolments.forEach(x => {
      x.Enrolments.forEach(enrolment => {
        if (!enrolment.IsPrimary) enrolment.isInfoIncomplete = (!enrolment.FirstName || !enrolment.LastName || !enrolment.EmailAddress || !enrolment.Phone)
      })
    })
  }

  excludePrimaryContactIfItsLearner() {
    this.classRoom.PendingGroupEnrolments.forEach(element => {
      let primaryContact = element.Enrolments.find(a => a.IsPrimary);
      if (primaryContact) {
        let primaryLearner = element.Enrolments.find(a => a.IsPrimaryLearner);
        if (primaryLearner) element.Enrolments.splice(element.Enrolments.indexOf(primaryContact), 1);
      }
    });
    this.classRoom.CancelledGroupEnrolments.forEach(element => {
      let primaryContact = element.Enrolments.find(a => a.IsPrimary);
      if (primaryContact) {
        let primaryLearner = element.Enrolments.find(a => a.IsPrimaryLearner);
        if (primaryLearner) element.Enrolments.splice(element.Enrolments.indexOf(primaryContact), 1);
      }
    });
  }

  confirmEnrolment() {
    this.updatedPendingRegistrationIds = [];
    this.isEnrolmentCancelled = false;
    this.selectedPendingRegistrationIds.forEach((id) => {
      this.courseService
        .GetEnrolmentDetailsByGroupIdOrRegistrationId(id)
        .subscribe((enrolmentDetails) => {
          enrolmentDetails.CourseEnrolments.forEach((courseEnrolment) => {
            courseEnrolment.EnrolmentStatus =
              EnrolmentStatus.EnrolmentStatusConfirmed;
            courseEnrolment.EnrolmentType = EnrolmentType.TrainingProvider
            this.courseService
              .SaveCourseEnrolments([courseEnrolment])
              .subscribe((data) => {
                if (data) {
                  this.showPendingEnrolmentConfirmedBanner = true;
                  this.updatedPendingRegistrationIds.push(id);
                  if (this.updatedPendingRegistrationIds.length == this.selectedPendingRegistrationIds.length) {
                    this.selectedPendingRegistrationIds = [];
                    this.enrolmentsConfirmed = true;
                    this.loadEnrolments();
                  }
                }
              });
          });
        });
    });

  }

  checkClassLastOrCompleteDate(): boolean {
    if (this.classRoom.TrainingType?.TrainingTypeId.toLocaleLowerCase() == this.tpAppUtils.eLearning) {
      return this.selectedConfirmedRegistrationIds.length > 0;
    } else {
      var classEndDate = this.classRoom.ClassTimes[this.classRoom.ClassTimes.length - 1].ClassDate
      return ((this.selectedConfirmedRegistrationIds.length > 0) && ((new Date(classEndDate)) < this.formatUtil.getUTCNow()))
    }
  }

  submitRecordsOfCompletion(): void {
    var selEnrolments = new Array();
    this.classRoom.ConfirmedGroupEnrolments.forEach(egroup => {
      egroup.Enrolments.forEach(enrolment => {
        this.selectedConfirmedRegistrationIds.forEach(sid => {
          if (enrolment.RegistrationId == sid)
            selEnrolments.push(enrolment);
        })
      })
    });
    sessionStorage.setItem('classroom-details', JSON.stringify(this.classRoom));
    sessionStorage.setItem('confirmed-enrolments', JSON.stringify(selEnrolments));
    sessionStorage.setItem('training-program', JSON.stringify(this.TrainingProgramApplicationList[0]));

    let navUrl = this.currentLang == 'en' ? '/training-provider/preview-records-completion' : 'fr/training-provider/preview-records-completion';
    this.router.navigate([navUrl]);
  }

  moveToPending() {
    let request = new BulkCourseEnrolmentStatusUpdate;
    request.GroupOrRegistrationIds = this.isCancelledEnroledTabSelected ? this.selectedCancelledRegistrationIds : this.selectedConfirmedRegistrationIds;
    request.EnrolmentStatus = EnrolmentStatus.EnrolmentStatusPending;
    request.EnrolmentType = EnrolmentType.TrainingProvider
    this.courseService
      .UpdateEnrolmentDetailsInBulkByGroupIdOrRegistrationId(request)
      .subscribe((data) => {
        this.isEnrolmentCancelled = false;
        if (data) {
          if (this.isCancelledEnroledTabSelected) {
            this.selectedCancelledRegistrationIds = [];
            this.showCancelledEnrolmentConfirmedBanner = true;
          } else {
            this.selectedConfirmedRegistrationIds = [];
            this.showPendingEnrolmentConfirmedBanner = true;
          }
          this.loadEnrolments();
        }
      });
  }

  moveToPendingDisabled(): boolean {
    if (this.isCancelledEnroledTabSelected) {
      return this.selectedCancelledRegistrationIds.length == 0;
    } else if (this.isConfirmedEnroledTabSelected) {
      return this.selectedConfirmedRegistrationIds.length == 0;
    }
    return true;
  }

  hasIncompleteLearners(): boolean {
    let result = false;
    for (const enrolmentGroup of this.classRoom.PendingGroupEnrolments) {
      for (const enrolment of enrolmentGroup.Enrolments) {
        if (enrolment.EnrolmentStatus == EnrolmentStatus.EnrolmentStatusPending &&
          (!enrolment.FirstName || !enrolment.LastName || !enrolment.EmailAddress || !enrolment.Phone)) {
          this.incompletedPendingRegistrationIds.push(enrolment.RegistrationId!);
          result = true;
        }
      }
    }
    return result;
  }

  downloadRoC() {
    this.bannerState = 0;
    this.courseService.DownloadRecordOfCompletion(this.selectedConfirmedRegistrationIds).subscribe((x: any) => {
      var a = document.createElement("a");
      a.setAttribute('style', 'display: none');
      document.body.appendChild(a);
      var data = [this.tpAppUtils.Base64ToArrayBuffer(x.response)];
      var blob = new Blob(data, { type: 'octet/stream' });
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `${this.classRoom.TrainingProgram!.Name.trim().replace(' - ', ' ')}-roc.pdf`.replace(/\s+/g, '-').toLocaleLowerCase();
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.bannerState = this.selectedConfirmedRegistrationIds.length < 2 ? 1 : 2;
    }, err => {
      this.bannerState = 11;
    });
  }

  shareRoC() {
    this.bannerState = 0;
    this.courseService.SendRecordOfCompletion(this.selectedConfirmedRegistrationIds).subscribe((x: any) => { this.bannerState = this.selectedConfirmedRegistrationIds.length < 2 ? 21 : 22; },
      error => { this.bannerState = 31 });
  }
}
